import styled from 'styled-components';
import { Label as LabelStyle } from 'components/styles';

export const Label = styled.label`
  ${LabelStyle};
  margin-bottom: var(--spacing-03);
  border: 0;
  display: inline-block;
  padding: 0;
`;

export const MandatoryLabel = styled(Label)`
  &:before {
    content: '* ';
    color: red;
  }
`;

export const LabelForGhostInput = styled(Label)`
  padding-left: var(--spacing-05);
  padding-right: var(--spacing-05);
`;
